export default __webpack_public_path__ + "static/media/20c.032d2756.svg";